import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { EdgePoolsPayload } from '~src/settings/bridge-settings/sections/types/EdgePoolsPayload';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { EdgePoolError } from '../../sections/types/EdgePoolError';

export interface IGetEdgePoolsParams {
  siteId: string;
}

export interface IGetEdgePoolsResult extends IResult {
  success?: EdgePoolsPayload;
  error?: EdgePoolError;
  bridgeSettingsVersion: string;
}

export class GetEdgePoolsRequest extends Request<IGetEdgePoolsParams, IGetEdgePoolsResult> {
  constructor(params: IGetEdgePoolsParams) {
    super('getEdgePools', params);
  }
}
